import { jwtDecode } from 'jwt-decode';

export function getJwtExpiryDuration(token) {
  try {
    const { exp } = jwtDecode(token);
    if (exp) {
      const remaining = (exp * 1000) - Date.now();
      if (remaining > 0) return remaining;
    }
  } catch (e) {
    // Fall through to default
  }
  return 60 * 60 * 1000; // fallback: 1 hour
}

/**
 * Maps verification object field names (backend) → proof names (frontend).
 * The verification object uses backend field names like `photo_verification_url`,
 * but formatProofLabel() expects proof names like `pg_photo_verification_url`.
 * Mirrors PROOF_TO_VERIFICATION_FIELD from backend/api/proofs/jwt_handler.py.
 */
const VERIFICATION_FIELD_TO_PROOF = {
  full_name: 'name',
  phone_number: 'phone_number',
  region: 'pg_region',
  hardware_attestation_id: 'pg_attestation_key_id',
  photo_verification_url: 'pg_photo_verification_url',
  presence: 'pg_presence',
  certainty: 'pg_high_certainty',
};

/**
 * Extract displayable data from a verification JWT bundle.
 * The bundle is either a JSON string or an object with { exp, verification: { ... } }.
 */
export function decodeVerificationClaims(verificationJWT) {
  if (!verificationJWT) return null;
  try {
    const jwtData = typeof verificationJWT === 'string'
      ? JSON.parse(verificationJWT)
      : verificationJWT;
    const verification = jwtData?.verification;
    if (!verification) return null;

    const photoUrl = verification.photo_verification_url || null;

    const proofs = [];
    for (const [field, proofName] of Object.entries(VERIFICATION_FIELD_TO_PROOF)) {
      if (verification[field] != null && verification[field] !== false) {
        proofs.push(proofName);
      }
    }

    return {
      photoUrl,
      proofs,
      fullName: verification.full_name || null,
      email: verification.email || null,
    };
  } catch {
    return null;
  }
}
